import { useTheme } from '@mui/material/styles';
import { DEFAULT_BRAND_COLORS } from './brandTokens';
import { buildBrandPalette } from './buildBrandPalette';

const DEFAULT_PALETTE = buildBrandPalette(DEFAULT_BRAND_COLORS);

/**
 * Concrete (hex) brand palette of the nearest BrandThemeProvider. Use it only
 * where CSS variables cannot work, e.g. chart series colours or alpha() maths.
 */
const useBrandPalette = () => useTheme().brand || DEFAULT_PALETTE;

export default useBrandPalette;
